var _a;
export var EmailErrorCode;
(function (EmailErrorCode) {
    EmailErrorCode["InvalidEmail"] = "invalid_email";
    EmailErrorCode["InvalidDomain"] = "invalid_domain";
    EmailErrorCode["RejectedEmail"] = "rejected_email";
    EmailErrorCode["InvalidSMTP"] = "invalid_smtp";
    EmailErrorCode["NoConnect"] = "no_connect";
    EmailErrorCode["Timeout"] = "timeout";
    EmailErrorCode["UnavailableSMTP"] = "unavailable_smtp";
    EmailErrorCode["UnexpectedError"] = "unexpected_error";
    EmailErrorCode["AcceptedEmail"] = "accepted_email";
    EmailErrorCode["LowQuality"] = "low_quality";
    EmailErrorCode["LowDeliverability"] = "low_deliverability";
})(EmailErrorCode || (EmailErrorCode = {}));
export var EmailError;
(function (EmailError) {
    EmailError["InvalidEmail"] = "h24_newsletter_invalid_email_error";
    EmailError["RequestTryAgain"] = "h24_newsletter_try_again";
})(EmailError || (EmailError = {}));
export var EmailErrorsMapping = (_a = {},
    _a[EmailErrorCode.InvalidEmail] = EmailError.InvalidEmail,
    _a[EmailErrorCode.InvalidDomain] = EmailError.InvalidEmail,
    _a[EmailErrorCode.RejectedEmail] = EmailError.InvalidEmail,
    _a[EmailErrorCode.InvalidSMTP] = EmailError.RequestTryAgain,
    _a[EmailErrorCode.NoConnect] = EmailError.RequestTryAgain,
    _a[EmailErrorCode.Timeout] = EmailError.RequestTryAgain,
    _a[EmailErrorCode.UnavailableSMTP] = EmailError.RequestTryAgain,
    _a[EmailErrorCode.UnexpectedError] = EmailError.RequestTryAgain,
    _a);
